import * as React from 'react';
import { SidebarItemExpandable } from './Sidebar';
import { SidebarItem } from './SidebarItem';
import { AppUser } from 'Src/views/App/App';
import { getUserActiveSchoolSubscriptionPlan } from '../../helpers/user/user';

interface SidebarItemsProps {
  item: SidebarItemExpandable;
  user: AppUser;
  isOpen: boolean;
  isCurrentGroup: boolean;
  onToggle: () => void;
}

export class SidebarItems extends React.Component<SidebarItemsProps> {
  onToggle = event => {
    event.preventDefault();
    this.props.onToggle();
  };

  render() {
    const { title, items } = this.props.item;
    const { user, isOpen, isCurrentGroup } = this.props;

    const visibleItems = items.filter(item =>
      item.visibleToSchoolSubscriptions.some(subscription => subscription === getUserActiveSchoolSubscriptionPlan(user))
    );

    const itemsWithNotifications = visibleItems.filter(item => typeof item.notificationCount !== 'undefined');
    const notificationsCountsSum = itemsWithNotifications.reduce(
      (sum, current) => sum + Number(current.notificationCount),
      0
    );
    const isNotificationToShow = notificationsCountsSum > 0 && !isOpen;

    if (visibleItems.length === 0) {
      return null;
    }

    return (
      <div className={`eSidebarGroup${isOpen ? ' mSidebarGroupOpen' : ''}${isCurrentGroup ? ' is-active' : ''}`}>
        <button type="button" className="eSidebarItemExpandable" onClick={this.onToggle} aria-expanded={isOpen}>
          <div className="eSidebarItemExpandableTitle">
            <div className="eSidebarItemNotificationWrapper">
              <span className="eSidebarItemTitle">{title}</span>
              {isNotificationToShow && <span className="eSidebarItemNotification">{notificationsCountsSum}</span>}
            </div>
          </div>

          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            className={
              isOpen ? 'eSidebarItemExpandableIcon mSidebarItemExpandableIconOpen' : 'eSidebarItemExpandableIcon'
            }
          >
            <path d="M9 6l6 6-6 6" />
          </svg>
        </button>

        {isOpen && (
          <ul className="nav flex-column">
            {visibleItems.map((item, index) => (
              <li key={`sidebar_expandable_item_${index}`} className="nav-item">
                <SidebarItem item={item} user={user} />
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  }
}
